(function () {
  /* ===== Fix scroll au retour du zoom modal — mobile ET desktop ===== */
  (function () {
    var modal = document.querySelector('.product-media-modal');
    if (!modal) return;

    var savedScrollY = 0;

    // Dawn dispatche 'modalClosed' AVANT removeTrapFocus(opener) → on patche focus()
    // avec preventScroll:true pour bloquer le scroll déclenché par opener.focus().
    document.body.addEventListener('modalClosed', function () {
      if (!modal.hasAttribute('open')) return;
      var origFocus = HTMLElement.prototype.focus;
      HTMLElement.prototype.focus = function (opts) {
        origFocus.call(this, Object.assign({}, opts, { preventScroll: true }));
      };
      setTimeout(function () { HTMLElement.prototype.focus = origFocus; }, 200);
    });

    new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        savedScrollY = window.scrollY;
      } else {
        requestAnimationFrame(function () {
          window.scrollTo(0, savedScrollY);
        });
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  })();

  /* ===== Mobile uniquement ===== */
  if (window.innerWidth > 749) return;

  /* ===== Pinch-to-zoom + pan sur un élément ===== */

  function makePinchZoomable(item, onZoomChange) {
    var img = item.tagName === 'IMG' ? item : item.querySelector('img');
    if (!img) return;

    var scale = 1, panX = 0, panY = 0;
    var startDist = 0, startScale = 1;
    var lastX = 0, lastY = 0;
    var lastTap = 0;

    function dist(t) {
      return Math.hypot(t[1].clientX - t[0].clientX, t[1].clientY - t[0].clientY);
    }

    function apply(animated) {
      img.style.transition = animated ? 'transform 0.2s ease' : 'none';
      img.style.transform = 'scale(' + scale + ') translate(' + panX + 'px,' + panY + 'px)';
    }

    function reset(animated) {
      scale = 1; panX = 0; panY = 0;
      apply(animated !== false);
      if (onZoomChange) onZoomChange(1);
    }

    // Listener non-passif — enregistré uniquement pendant un geste zoom/pan actif.
    // Sans lui, iOS peut scroller la page sans attendre le JS.
    function zoomMoveHandler(e) {
      if (e.touches.length === 2) {
        scale = Math.max(1, Math.min(4, startScale * dist(e.touches) / startDist));
        apply(false);
        if (onZoomChange) onZoomChange(scale);
        e.preventDefault();
        e.stopPropagation();
      } else if (e.touches.length === 1 && scale > 1) {
        panX += (e.touches[0].clientX - lastX) / scale;
        panY += (e.touches[0].clientY - lastY) / scale;
        lastX = e.touches[0].clientX;
        lastY = e.touches[0].clientY;
        apply(false);
        e.preventDefault();
        e.stopPropagation();
      }
    }

    // touchstart passif → iOS peut démarrer le scroll vertical immédiatement.
    // Le listener non-passif n'est ajouté que si un zoom/pan est nécessaire.
    item.addEventListener('touchstart', function (e) {
      item.removeEventListener('touchmove', zoomMoveHandler);
      if (e.touches.length === 2) {
        startDist = dist(e.touches);
        startScale = scale;
        item.addEventListener('touchmove', zoomMoveHandler, { passive: false });
      } else if (e.touches.length === 1 && scale > 1) {
        lastX = e.touches[0].clientX;
        lastY = e.touches[0].clientY;
        item.addEventListener('touchmove', zoomMoveHandler, { passive: false });
      }
    }, { passive: true });

    item.addEventListener('touchend', function (e) {
      item.removeEventListener('touchmove', zoomMoveHandler);
      if (scale < 1.05) reset(true);
      var now = Date.now();
      if (now - lastTap < 300 && e.changedTouches.length === 1) reset(true);
      lastTap = now;
    });
  }

  /* ===== Carrousel PDP principal ===== */

  function init() {
    document.querySelectorAll('.product__media-list.slider--mobile').forEach(function (list) {
      var slides = list.querySelectorAll('.product__media-item.slider__slide');
      if (slides.length <= 1) return;

      var sliderWrap = list.closest('slider-component');
      if (!sliderWrap || sliderWrap.dataset.aikaraDots) return;
      sliderWrap.dataset.aikaraDots = '1';

      Array.from(slides).forEach(function (slide) {
        makePinchZoomable(slide, function (s) {
          list.style.overflowX = s > 1.05 ? 'hidden' : '';
        });
      });

      var navEl = document.createElement('div');
      navEl.className = 'aikara-carousel-nav';

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'aikara-carousel-arrow aikara-carousel-arrow--prev';
      prevBtn.setAttribute('aria-label', 'Photo précédente');
      prevBtn.innerHTML = '<svg viewBox="0 0 8 14" width="8" height="14" fill="none"><path d="M7 1L1 7l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

      var dotsEl = document.createElement('div');
      dotsEl.className = 'aikara-carousel-dots';

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'aikara-carousel-arrow aikara-carousel-arrow--next';
      nextBtn.setAttribute('aria-label', 'Photo suivante');
      nextBtn.innerHTML = '<svg viewBox="0 0 8 14" width="8" height="14" fill="none"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

      var dots = Array.from(slides).map(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'aikara-carousel-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Photo ' + (i + 1));
        dot.addEventListener('click', function () {
          list.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        });
        dotsEl.appendChild(dot);
        return dot;
      });

      navEl.appendChild(prevBtn);
      navEl.appendChild(dotsEl);
      navEl.appendChild(nextBtn);

      sliderWrap.parentNode.insertBefore(navEl, sliderWrap.nextSibling);

      function currentIndex() {
        return Math.round(list.scrollLeft / (list.clientWidth || 1));
      }

      prevBtn.addEventListener('click', function () {
        var idx = Math.max(0, currentIndex() - 1);
        list.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        var idx = Math.min(slides.length - 1, currentIndex() + 1);
        list.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      });

      var ticking = false;
      list.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var idx = currentIndex();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          prevBtn.style.opacity = idx === 0 ? '0.3' : '1';
          nextBtn.style.opacity = idx === slides.length - 1 ? '0.3' : '1';
          ticking = false;
        });
      }, { passive: true });

      prevBtn.style.opacity = '0.3';
    });
  }

  /* ===== Carrousel dans la modale zoom (mobile) ===== */

  function initZoomModal() {
    var modal = document.querySelector('.product-media-modal');
    if (!modal || modal.dataset.aikaraZoom) return;
    modal.dataset.aikaraZoom = '1';

    var content = modal.querySelector('.product-media-modal__content');
    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (!content || !dialog) return;

    var items = Array.from(content.children);
    if (items.length < 2) return;

    items.forEach(function (item) {
      makePinchZoomable(item, function (s) {
        content.style.overflowX = s > 1.05 ? 'hidden' : '';
      });
    });

    var nav = document.createElement('div');
    nav.className = 'aikara-zoom-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'aikara-carousel-arrow aikara-carousel-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Photo précédente');
    prevBtn.innerHTML = '<svg viewBox="0 0 8 14" width="8" height="14" fill="none"><path d="M7 1L1 7l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    var dotsEl = document.createElement('div');
    dotsEl.className = 'aikara-carousel-dots';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'aikara-carousel-arrow aikara-carousel-arrow--next';
    nextBtn.setAttribute('aria-label', 'Photo suivante');
    nextBtn.innerHTML = '<svg viewBox="0 0 8 14" width="8" height="14" fill="none"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    var dots = items.map(function (item, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'aikara-carousel-dot';
      dot.setAttribute('aria-label', 'Photo ' + (i + 1));
      dot.addEventListener('click', function () {
        content.scrollTo({ left: i * content.clientWidth, behavior: 'smooth' });
      });
      dotsEl.appendChild(dot);
      return dot;
    });

    nav.appendChild(prevBtn);
    nav.appendChild(dotsEl);
    nav.appendChild(nextBtn);
    dialog.appendChild(nav);

    function currentZoomIndex() {
      return Math.round(content.scrollLeft / (content.clientWidth || window.innerWidth));
    }

    function updateZoomNav(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      prevBtn.style.opacity = idx === 0 ? '0.3' : '1';
      nextBtn.style.opacity = idx === items.length - 1 ? '0.3' : '1';
    }

    prevBtn.addEventListener('click', function () {
      var idx = Math.max(0, currentZoomIndex() - 1);
      content.scrollTo({ left: idx * content.clientWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      var idx = Math.min(items.length - 1, currentZoomIndex() + 1);
      content.scrollTo({ left: idx * content.clientWidth, behavior: 'smooth' });
    });

    var ticking = false;
    content.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateZoomNav(currentZoomIndex());
        ticking = false;
      });
    }, { passive: true });

    // Sync carousel position avec la modale à l'ouverture
    new MutationObserver(function () {
      var mainList = document.querySelector('.product__media-list.slider--mobile');
      if (modal.hasAttribute('open')) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (mainList) mainList.scrollTop = 0;
            var activeIdx = items.findIndex(function (el) {
              return el.classList.contains('active');
            });
            if (activeIdx < 0) activeIdx = 0;
            content.scrollLeft = activeIdx * content.clientWidth;
            updateZoomNav(activeIdx);
          });
        });
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () { init(); initZoomModal(); }, 50);
    });
  } else {
    setTimeout(function () { init(); initZoomModal(); }, 50);
  }

  function resetCarousel() {
    var list = document.querySelector('.product__media-list.slider--mobile');
    if (!list) return;
    list.querySelectorAll('.product__media-item img').forEach(function (img) {
      img.style.transform = '';
      img.style.transition = '';
    });
    list.scrollLeft = 0;
    window.scrollTo(0, 0);
    list.querySelectorAll('.product__media-item.scroll-trigger').forEach(function (slide) {
      slide.style.opacity = '1';
      slide.style.transform = 'none';
    });
  }

  window.addEventListener('pageshow', function () {
    requestAnimationFrame(function () { resetCarousel(); });
  });
})();
